import React from 'react';
import {getStationName} from "../util/CommonUtils";
import {publishCountToCSM} from "../util/CommonUtils";
import ErrorPage from "./error/ErrorPage";

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        // You can also log the error to an error reporting service
        const metricProcessName = "SCC_PACKAGE_SUMMARY_" + getStationName();
        const metricName = "clientError";
        publishCountToCSM({
            processName: metricProcessName,
            metricName: metricName
        });
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return <ErrorPage/>;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;


// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.js